import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../services/ApiService'
import { showAlert } from '../../utility/SweetAlert'

const InteractorProductMediaCreate = () => {
  const { t } = useTranslation()
  const productMediaCreate = useCallback(
    (uid, payload) => {
      ApiService.jsonRequest('/product-media/create', payload, response => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t('message.successfully_created'),
            timer: 1500,
            redirect: `/product/update?uid=${uid}`,
          })
        }
      })
    },
    [t],
  )
  return { productMediaCreate }
}

export default InteractorProductMediaCreate
